<template>
  <div id="home">
    <HomeHeader></HomeHeader>
    <div class="flex flex1 justify-start home__body">
      <Menu style="width: 270px"></Menu>
      <div class="flex1" style="padding: 1em; overflow: hidden">
        <router-view class="flex1" style="height: calc(100%); overflow-y: hidden"></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import HomeHeader from '@/components/layout/HomeHeader'
import Menu from '@/components/layout/Menu'

export default {
  name: 'Home',
  components: {
    HomeHeader,
    Menu,
  },
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroy() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.home__body {
  overflow: hidden;
  height: calc(100vh - 60px);
  background-color: #f5f5f5;
}
</style>
<style lang="scss"></style>
